module.exports = __webpack_public_path__ + "static/52-9068f037fe64217d03a9b128cd544bf3.png";